export default function huquqPageEndpoint(context, contentName) {
  const query = context.digitalDesignContent.items().type('huquqpage').orderParameter('elements.base__datepublished', 'asc');
  const updatedQuery = contentName ? query.equalsFilter('system.codename', contentName) : query;
  const observable = updatedQuery.toObservable();
  return observable;
}
